import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  LOGIN,
  LOGOUT,
  USER_REG,
  FORGOT_PASSWORD,
  RESETPASSWORD,
  IMPORT_USERS,
  CHANGE_PASSWORD,
  GET_CAPTCHA_CODE,
} from '../../../api/apiConstant';
import api from '../../../api/apiServises';

export const userLogin = createAsyncThunk(
  'auth/userLogin',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.post(LOGIN, credentials);
      console.log('responseData', response);

      // Extract token from the response (removing "Bearer " prefix if present)
      let token = response.data?.data?.[0]?.access_token || null;

      // Clean the token if it has "Bearer " prefix
      if (token && token.startsWith('Bearer ')) {
        token = token.substring(7); // Remove "Bearer " prefix
      }
      let refreshToken = response.data?.data?.[0]?.refresh_token || null;
      if (refreshToken && refreshToken.startsWith('Bearer ')) {
        refreshToken = refreshToken.substring(7);
      }
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
      }
      // Extract user data
      const user = response.data?.data?.[0]?.user || null;

      return {
        token,
        refreshToken,
        user,
        // Return the full response if needed elsewhere
        response: response.data,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const userLogout = createAsyncThunk(
  'auth/logout', // Fixed: removed leading slash
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token || localStorage.getItem('token');

      if (!token) {
        throw new Error('No token found');
      }

      const response = await api.post(
        LOGOUT,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log('response-------------', response);

      // Clean up localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('refreshToken');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const addUser = createAsyncThunk('auth/addUser', async (user, { rejectWithValue }) => {
  try {
    // console.log(1212,user);
    const response = await api.post(USER_REG, user);
    console.log(123, response);
    return response.user;
  } catch (error) {
    // Handle validation errors from Laravel
    if (error.response?.data?.errors) {
      return rejectWithValue({
        errors: error.response.data.errors,
        message: error.response.data.message,
      });
    }
    return rejectWithValue(
      error.response?.user?.message || error.message || 'Registration successfully',
    );
  }
});

export const forgotPassWord = createAsyncThunk(
  'auth/gorgot_password',
  async (email, { rejectWithValue }) => {
    try {
      // console.log(1212,user);
      const response = await api.post(FORGOT_PASSWORD, email);
      console.log(123, response);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.email?.message || error.message || 'OTP Send successfully',
      );
    }
  },
);

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(RESETPASSWORD, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to reset password');
    }
  },
);

export const importUsers = createAsyncThunk(
  'auth/importUsers',
  async (formData, { rejectWithValue }) => {
    try {
      console.log(657, formData);
      const response = await api.post(IMPORT_USERS, formData);
      console.log('Import users response:', response);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// export const fetchAllUser = createAsyncThunk(
//   'auth/fetchAllUser',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(FETCH_USER);
//       console.log(909, response)
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   },
// );

export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (formData, { rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const token = auth?.token || localStorage.getItem('token');

      const response = await api.post(CHANGE_PASSWORD, formData);
      console.log(146, response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to change password');
    }
  },
);

export const getCaptchCode = createAsyncThunk(
  'auth/captchaCode',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_CAPTCHA_CODE);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to generate captcha code');
    }
  },
);
